import React from 'react';
import { getIsAdopted, getIsOnSale, getIsPending } from '../../../../utils/adoptables';
import AdoptOnSide from './_partials/AdoptOnSide';
import AdoptedOnSide from './_partials/AdoptedOnSide';
import s from './AdoptableInfo.scss';
const AdoptableInfo = ({ deviation  })=>{
    var _deviation_extended, _deviation_extended_adoptable;
    const canAdopt = (_deviation_extended = deviation.extended) === null || _deviation_extended === void 0 ? void 0 : (_deviation_extended_adoptable = _deviation_extended.adoptable) === null || _deviation_extended_adoptable === void 0 ? void 0 : _deviation_extended_adoptable.canAdopt;
    const isAdopted = getIsAdopted(deviation);
    const isOnSale = getIsOnSale(deviation);
    const isPending = getIsPending(deviation);
    if (isAdopted) {
        return /*#__PURE__*/ React.createElement("div", {
            className: s['root']
        }, /*#__PURE__*/ React.createElement(AdoptedOnSide, {
            deviation: deviation
        }));
    }
    if (canAdopt && (isOnSale || isPending)) {
        return /*#__PURE__*/ React.createElement("div", {
            className: s['root']
        }, /*#__PURE__*/ React.createElement(AdoptOnSide, {
            deviation: deviation
        }));
    }
    return null;
};
AdoptableInfo.displayName = 'AdoptableInfo';
export default AdoptableInfo;
